// import React from 'react';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// ChartJS.register(ArcElement, Tooltip, Legend);

// interface UsageData {
//   name: string;
//   value: number;
// }

// interface PieChartProps {
//   title: string;
//   data: UsageData[];
//   totalHours: number;
// }

// export const PieChart: React.FC<PieChartProps> = ({ title, data, totalHours }) => {

//   const createChartData = (data: UsageData[]) => {
//     const labels = data.map((item) => item.name);
//     const values = data.map((item) => item.value);
//     const colors = ['#EDF0FF', '#4466FF', '#44FFBC', '#9AACFF', '#A7B7FF',];
//     return {
//       labels,
//       datasets: [
//         {
//           data: values,
//           backgroundColor: colors,
//           borderWidth: 1,
//         },
//       ],
//     };
//   };

//   // Chart options for thinner ring
//   const chartOptions = {
//     cutout: '85%',
//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         enabled: true,
//       },
//     },
//     responsive: true,
//     maintainAspectRatio: false,
//   };

//   return (
//     <div className="bg-white rounded-lg  p-6 flex items-center w-full" style={{ boxShadow: '0px 0px 6px 1px rgba(0, 0, 0, 0.15)' }}>
//       {/* Pie Chart Container */}
//       <div className="relative w-[100px] h-[100px] flex-shrink-0">
//         <Pie data={createChartData(data)} options={chartOptions} />
//         <div className="absolute inset-0 flex flex-col items-center justify-center">
//           <span className="text-[#00000080] text-xs">Total</span>
//           <span className="text-[#000000] font-bold">
//             {totalHours > 1000000
//               ? `${(totalHours / 1000000).toFixed(2)}M hr`
//               : `${totalHours} hr`
//             }
//           </span>

//         </div>
//       </div>
//       {/* Usage Details */}
//       <div className="ml-6 flex-1">
//         <h3 className="text-sm leading-[20px] font-semibold mb-[7px]">{title}</h3>
//         <ul>
//           {data.map((item, index) => (
//             <li key={index} className="flex justify-between items-center space-y-[6px]">
//               <span className="text-xs text-[#1E1E1E]">{item.name}</span>
//               <span className="text-xs text-[#1E1E1E]">
//                 {item.value}%
//               </span>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

import React from 'react';
import { Pie } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { _isValidUrl } from 'common/utility';

ChartJS.register(ArcElement, Tooltip, Legend);

interface UsageData {
  name: string;
  value: number;
}

interface PieChartProps {
  title: string;
  data: UsageData[];
  totalHours: number;
}

export const PieChart: React.FC<PieChartProps> = ({ title, data, totalHours }) => {
  const isValidData = Array.isArray(data) && data.length > 0;

  const createChartData = (data: UsageData[]) => {
    const labels = isValidData ? data.map((item) => item.name || 'Unknown') : [];
    const values = isValidData ? data.map((item) => item.value || 0) : [];
    const colors = ['#4466FF', '#44FFBC', '#9AACFF', '#A7B7FF', '#EDF0FF'];
    return {
      labels,
      datasets: [
        {
          data: values,
          backgroundColor: colors.slice(0, values.length),
          borderWidth: 1,
        },
      ],
    };
  };

  const chartOptions: ChartOptions<'pie'> = {
    cutout: '85%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: isValidData,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div
      className="bg-white rounded-lg p-6 flex items-center w-full"
      style={{ boxShadow: '0px 0px 6px 1px rgba(0, 0, 0, 0.15)' }}
    >
      {/* Pie Chart Container */}
      <div className="relative flex-shrink-0" style={{ width: '100px', height: '100px' }}>
        {isValidData ? (
          <Pie data={createChartData(data)} options={chartOptions} />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-500">
            No Data Available
          </div>
        )}
        {isValidData && (
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-[#00000080] text-xs">Total</span>
            <span className="text-[#000000] font-bold">
              {totalHours >= 1e12
                ? `${(totalHours / 1e12).toFixed(1)}T hr`
                : totalHours >= 1e9
                  ? `${(totalHours / 1e9).toFixed(1)}B hr`
                  : totalHours >= 1e6
                    ? `${(totalHours / 1e6).toFixed(1)}M hr`
                    : totalHours >= 1e3
                      ? `${(totalHours / 1e3).toFixed(1)}K hr`
                      : `${totalHours} hr`}
            </span>

          </div>
        )}
      </div>
      {/* Usage Details */}
      <div className="ml-6 flex-1 overflow-x-auto">
        <p className="text-sm text-black leading-[20px] font-semibold mb-[7px]">{title}</p>
        {isValidData ? (
          <ul>
            {data.map((item, index) =>
              _isValidUrl(item.name) ? (
                <li
                  key={index}
                >
                  <a
                    href={item.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex justify-between items-center space-y-[6px]"
                  >
                    <span
                      className="text-xs text-[#1E1E1E] truncate overflow-hidden w-[80%] relative"
                      style={{ whiteSpace: 'nowrap' }}
                      title={item.name}
                    >
                      {item.name.length > 70 ? item.name.substring(0, 70) + '...' : item.name}
                    </span>
                    <span className="text-xs text-[#1E1E1E]">{item.value}%</span>
                  </a>
                </li>
              ) : (
                <li key={index} className="flex justify-between items-center space-y-[6px]">
                  <span
                    className="text-xs text-[#1E1E1E] truncate overflow-hidden w-[80%] hover:whitespace-normal hover:w-auto relative"
                    style={{ whiteSpace: 'nowrap' }}
                    title={item.name}
                  >
                    {item.name.length > 70 ? item.name.substring(0, 70) + '...' : item.name}
                  </span>
                  <span className="text-xs text-[#1E1E1E]">{item.value}%</span>
                </li>
              )
            )}
          </ul>
        ) : (
          <div className="text-xs text-gray-500">No usage details available</div>
        )}
      </div>
    </div>
  );
};
